// @flow
import React from 'react';
import type { ChildrenArray, Element } from 'react';
import { usePropsValidation } from '../validation/runtime-checks/index.js';
import { types as t } from '../validation/runtime-checks/prop-spec.js';
import { Text } from '../Text.js';
import Image from '../Image.js';

export default function GlossaryTermLocale(props: {|
  term: string,
  // This is no longer rendered in this component. It is used purely for configuration
  // and to properly insert the record into the mathspace database.
  locale: 'EN_AU' | 'EN_GB' | 'EN_US' | 'ES' | 'FR' | 'HT_HT' | 'PT',
  children: ChildrenArray<Element<typeof Text> | Element<typeof Image>>,
|}) {
  const { failedValidation } = usePropsValidation(props, GlossaryTermLocale);
  if (failedValidation) return null;

  return (
    <>
      <Text>{props.term}</Text>
      {props.children}
    </>
  );
}

GlossaryTermLocale.spec = {
  term: t.string,
  // Ths list is coordinated with the mathspace backend
  locale: t.unionOfValues('EN_AU', 'EN_GB', 'EN_US', 'ES', 'FR', 'HT_HT', 'PT'),
  children: t.childrenArray(
    t.unionOfTypes(t.elementType(Text), t.elementType(Image)),
  ),
};
